import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_FILTER_BY_NAME_OR_PHONE,
	STR_NO_RECORD,
	STR_DOWNLOAD_CONTACTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdDownloading, MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdSearch } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import OneContact from '../ones/OneContact';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [filter, setFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllContacts(),
		])
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">
					<div className="col-md-12 mt-4 mb-4 text-end">
						<button
							className="btn btn-sm btn-padded bg-secondary btn-rounded"
							onClick={() => {
								appContext.navTo({
									item: 'view',
									subItem: 'create-contact',
								})
							}}
						>
							{STR_CREATE_NEW_CONTACT[appContext.language]}
							</button>
						
						<hr/>
					</div>

					<div className="col-12 mt-2 mb-2 d-flex">
						<MdSearch
							size={32}
							className="align-self-center"
							style={{
								flexShrink: "0",
							}}
						/>

						<input
							className="align-self-center form-control"
							placeholder={STR_FILTER_BY_NAME_OR_PHONE[appContext.language]}
							onChange={(e) => setFilter(e.target.value)}
							value={filter}
						/>
					</div>

					<div className="col-12">
						{
							(appContext.allContacts && appContext.allContacts.length > 0) ?
							appContext.allContacts.map((item, i) => {
								if(filter) {
									if(
										String(item.name).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
										String(item.whatsAppNumber).toLowerCase().indexOf(String(filter).toLowerCase()) > -1 ||
										String(item.phoneNumber).toLowerCase().indexOf(String(filter).toLowerCase()) > -1
									) {
										return <OneContact key={i} data={item}/>
									} else {
										return "";
									}
								} else {
									return <OneContact key={i} data={item}/>
								}
							})
							:
							<h6
								style={{
									fontSize: "14px",
								}}
							>
								{STR_NO_RECORD[appContext.language]}
							</h6>
						}
					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}